import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '2fd03b9f-0d9e-4f21-9a67-649d1199fb62',
	[AppLanguageCodes.SK]: '2fd03b9f-0d9e-4f21-9a67-649d1199fb62',
	[AppLanguageCodes.DE]: '2fd03b9f-0d9e-4f21-9a67-649d1199fb62',
}


export const Advantages = () => {

	return (
		<MdxDiv className='advantages' articleIds={articleIds}>
		</MdxDiv>
	);
};